import { sortSymtomsByClassifications } from 'helpers/pet.helpers';
import { authHeader } from 'services';
import { ITreatmentOnGoing } from 'types';

import { Api } from './api/axios.service';

const IMAGE_URL = `${process.env.REACT_APP_BASE_API_URL}/api/pet/image-download`;
const BASE_URL = '/treatment-on-going';

/**
 * Get current treatment by logged vet
 *
 * @return {*}  {Promise<ITreatmentOnGoing>}
 */
const getCurrentTreatmentOnGoing = async (): Promise<ITreatmentOnGoing> => {
  try {
    const headers = authHeader();

    const { data } = await Api.get<ITreatmentOnGoing>(
      `${BASE_URL}/current-treatment-on-going-by-vet`,
      {
        headers,
      }
    );

    if (!data) {
      throw new Error();
    }

    /* Get complete pet image with authentication */
    if (data.pet.image) {
      data.pet.imageUrl = `${IMAGE_URL}/${data.pet._id}/?access_token=${headers.Authorization}`;
    }

    data.symptoms = sortSymtomsByClassifications(data.symptoms);

    return data;
  } catch (reason: any) {
    const { message } = reason as Error;

    throw new Error(
      message || 'Não foi possível obter os dados da teleorientação'
    );
  }
};

export const TreatmentService = {
  getCurrentTreatmentOnGoing,
};
